import { takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  NgZone,
  AfterViewChecked,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import * as reducers from "../../reducers";
import { ViewportDetector } from "../../shared/viewport-detector";
import { ProductDetails } from "../../shared/interface/product-details";
import * as productActions from "../product.actions";
import { LayoutService } from "../../shared/service/layout.service";
import { CartService } from "../../shared/service/cart.service";
import { ProductCompare } from "../../shared/interface/product-compare";
import { ProductService } from "../product.service";
import {
  resizeImg,
  changeDRId,
  showOverlay,
  showImgError,
  getBuyButtonText,
  getFormatedPrice,
  getPriceIntegerDot,
  getPriceDecimal,
  extractDRPriceIntegerDot,
  extractDRPriceDecimal,
  productName,
} from "../../shared/utils/utils";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
declare var $: any;

@Component({
  selector: "product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.scss"],
})
export class ProductDetailsComponent implements OnInit, AfterViewChecked {
  @Input() screenWidth: string;
  @Input() productCompare: ProductCompare[];
  @Output() hatchOverlayDisplay = new EventEmitter();
  @Output() curViewType = new EventEmitter();
  @ViewChild("drId") drId: ElementRef;

  viewportType: string;
  layoutType: string;
  locale: string;
  thumbnailWGrid: number = 300;
  thumbnailHGrid: number = 231;
  thumbnailWListXL: number = 300;
  thumbnailHListXL: number = 231;
  thumbnailWListLG: number = 190;
  thumbnailHListLG: number = 107;
  changeDRId;
  productName;
  showImgError;
  getBuyButtonText;
  getPriceIntegerDot;
  getFormatedPrice;
  getPriceDecimal;
  extractDRPriceIntegerDot;
  extractDRPriceDecimal;
  setBottomMargin: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  productDetails: ProductDetails[] = [];
  afterViewChecked: boolean = false;
  featuredProductLoaded: boolean;
  drLoading: boolean = false;
  sessionStorageViewTypeKey: string = "-view-type";

  constructor(
    private store: Store<reducers.State>,
    private route: ActivatedRoute,
    private viewportDetector: ViewportDetector,
    private router: Router,
    private layoutService: LayoutService,
    private cartService: CartService,
    private elRef: ElementRef,
    private translate: TranslateService,
    private productService: ProductService
  ) {
    this.changeDRId = changeDRId;
    this.showImgError = showImgError;
    this.productName = productName;
    this.getBuyButtonText = getBuyButtonText;
    this.getPriceIntegerDot = getPriceIntegerDot;
    this.getFormatedPrice = getFormatedPrice;
    this.getPriceDecimal = getPriceDecimal;
    this.extractDRPriceIntegerDot = extractDRPriceIntegerDot;
    this.extractDRPriceDecimal = extractDRPriceDecimal;
    window.addEventListener(
      "orientationchange",
      () => {
        this.getViewType();
      },
      false
    );
  }
  valueTrimmer(v){
    let t;
    if (v.length>0) {
      t=v.trim()
    }
    return t;
  }
  @HostListener("window:resize") onScreenResize() {
    this.getViewType();
  }

  getPDPLink(productDetail) {
    let l = "";
    if (
      productDetail.category === "SWITCH_SYSTEMS" ||
      productDetail.category === "DPU"
    ) {
      l =
        "/" +
        this.locale +
        "/geforce/store/product/" +
        productDetail.productSKU.toLowerCase() +
        "/" +
        productDetail.productTitle
          .replace(productDetail.productSKU, " ")
          .replaceAll(" ", "-")
          .replaceAll("/", "-")
          .toLowerCase()
          .replace(/-+/gi, "-");
    } else if (productDetail.retailers.length > 0) {
      productDetail.retailers.forEach((element) => {
        if (element.partnerId === "111") {
          l = element.purchaseLink.split("/")[2];
        }
      });
    }

    return (
      "/" +
      this.locale +
      "/geforce/store/product/" +
      productDetail.productSKU.toLowerCase() +
      "/" +
      productDetail.productTitle
        .replace(productDetail.productSKU, " ")
        .replaceAll("+", "")
        .replaceAll(".", "-")
        .replaceAll(" ", "-")
        .replaceAll("/", "-")
        .toLowerCase()
        .replace(/-+/gi, "-") +
      "/"
    );
  }

  getViewType() {
    if (this.screenWidth === "SM") {
      this.layoutType = "grid";
      this.curViewType.emit("grid");
      this.saveViewType("grid");
    } else if (
      (this.screenWidth === "LG" || this.screenWidth === "XL") &&
      this.layoutType === "grid"
    ) {
      this.setGridBottomMargin();
    }
  }

  saveViewType(view) {
    try {
      localStorage.setItem(
        this.getCurLocale() + this.sessionStorageViewTypeKey,
        JSON.stringify(view)
      );
    } catch (e) {}
  }

  detectBuyClick() {
    $(".buy-link").on("click", function (event) {
      // modal neeraj
      var lastFocusedElement;
      lastFocusedElement = document.activeElement;
      setTimeout(function () {
        const FOCUSABLE_SELECTORS =
          "a.popClose, img, button,h1,div.cellPrice, div.bundle_icon_class, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

        const closeModalBtn = document.querySelector(".popClose");
        const modal = document.querySelector(".popBody");
        modal.classList.add("modal-active");
        const main = document.querySelector(".popBg");
        openModal();

        function openModal() {
          const focusableElements = Array.from(
            modal.querySelectorAll(FOCUSABLE_SELECTORS)
          );
          focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
          (modal.querySelector(FOCUSABLE_SELECTORS) as HTMLElement).focus();
          modal.removeAttribute("aria-hidden");
          main.setAttribute("aria-hidden", "true");
          closeModalBtn.addEventListener("click", modalClose);
        }
      }, 1000);

      function modalClose() {
        // Return the focus to the last focused element
        lastFocusedElement.focus();
      }
      //end modal focus neeraj
    });
  }

  ngAfterViewChecked() {
    if (
      !this.afterViewChecked &&
      (this.productDetails.length || this.featuredProductLoaded)
    ) {
      if (
        !localStorage.getItem("hasCompared") ||
        localStorage.getItem("hasCompared") == "" ||
        localStorage.getItem("hasCompared") == "null"
      ) {
        try {
          window["hatchwidgetHelpers"].reloadScript();
        } catch (err) {
          console.error("not found  widget helpers");
        }
      }
      try {
        window["searchHelpers"].hideFeatured();
      } catch (err) {
        console.error("not found  search helpers");
      }

      $(".js-product-item").removeData();
      if (
        !localStorage.getItem("hasCompared") ||
        localStorage.getItem("hasCompared") != "" ||
        localStorage.getItem("hasCompared") != "null"
      ) {
        setTimeout(function () {
          window["appSetupHelpers"].scanPID(
            localStorage.getItem("hasCompared")
          );
        }, 150);
      }
      this.afterViewChecked = true;
    }
  }

  ngOnInit() {
    var that = this;
    this.setStartViewType();
    window["hatchwidgetHelpers"].nvbuyinit();
    window["searchHelpers"].hideFeatured();
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.locale = params["locale"];
    });

    this.store
      .select(reducers.getProductDetails)
      .pipe(takeUntil(this.destroy$))
      .subscribe((productDetails) => {
        this.productDetails = productDetails;
        this.afterViewChecked = false;
      });

    this.store
      .select(reducers.getSuggestedProduct)
      .pipe(takeUntil(this.destroy$))
      .subscribe((suggestedProducts) => {
        if (suggestedProducts.productDetails.length > 0) {
          this.productDetails = suggestedProducts.productDetails;
          this.afterViewChecked = false;
        }
      });

    window.addEventListener("orientationchange", this.onOrientationChange);

    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        setTimeout(() => {
          $(".cart-main-section .cart__empty")[0] &&
            ($(".cart-main-section .cart__empty")[0].innerHTML =
              that.translate.instant("empty_cart"));
          $(".cart-main-section .cart__title")[0] &&
            ($(".cart-main-section .cart__title")[0].innerHTML =
              that.translate.instant("cart"));
          $(".cart-main-section .cart__items").each(function () {
            $(this)
              .find(".cart_remove .cart-item__remove")
              .each(function (i) {
                $(".cart_remove .cart-item__remove")[i].innerHTML =
                  that.translate.instant("remove");
              });
          });

          /*Hide featured text from all products except top 2*/

          console.log("On INIT Even after");
        }, 1000);
      });
  }

  onOrientationChange() {
    var mqp = window.matchMedia("(orientation: portrait)");
    var mql = window.matchMedia("(orientation: landscape)");
    if (/SHIELD/.test(navigator.userAgent) && (mqp.matches || mql.matches)) {
      window["hatchwidgetHelpers"].reloadScript();
      window["searchHelpers"].hideFeatured();

      $(".js-product-item").removeData();
      setTimeout(function () {
        window["appSetupHelpers"].scanPID("");
      }, 500);
    }
  }

  setStartViewType() {
    if (this.screenWidth === "SM") {
      this.layoutType = "grid";
    } else {
      this.retrieveViewType();
    }
    this.setGridBottomMargin();
  }

  retrieveViewType() {
    let view = "";
    try {
      view = JSON.parse(
        localStorage.getItem(
          this.getCurLocale() + this.sessionStorageViewTypeKey
        )
      );
    } catch (e) {}
    if (view === "grid" || view === "list") {
      this.layoutType = view;
    } else {
      this.layoutType = "list";
    }
    this.curViewType.emit(this.layoutType);
  }

  getCurLocale(): string {
    return window.location.pathname.split("/")[1];
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  fpLoaded(data) {
    this.featuredProductLoaded = data;
  }

  sendData(data: string) {
    this.layoutType = data;
    this.setGridBottomMargin();

    window["hatchwidgetHelpers"].reloadScript();
    window["searchHelpers"].hideFeatured();

    $(".js-product-item").removeData();
    setTimeout(function () {
      window["appSetupHelpers"].scanPID();
    }, 500);

    this.afterViewChecked = true;
    this.saveViewType(this.layoutType);
  }

  setGridBottomMargin() {
    this.setBottomMargin = false;
    if (this.layoutType === "grid") {
      this.setBottomMargin = true;
    }
  }

  compareProduct(productDetail) {
    let compareTranslatedLabel = "compare";
    localStorage.setItem("hasCompared", productDetail.digitialRiverID);
    let compareData = JSON.parse(
      localStorage.getItem(this.locale + "-compare")
    );
    let compareLabel = productDetail.addRemoveCompare;
    let total_item = 0;
    if (compareData && compareData != null) {
      for (let cpid of compareData) {
        if (cpid && cpid != null) {
          total_item = total_item + 1;
          if (cpid.productID == productDetail.productID) {
            compareLabel = "Remove";
          }
        }
      }
    }

    if (total_item == 0) {
      compareLabel = "Compare";
    }

    if (total_item <= 4) {
      if (compareLabel === "Compare") {
        this.translate
          .get("remove")
          .subscribe((r) => (compareTranslatedLabel = r));
        if (this.productCompare.indexOf(null) > -1) {
          $("button[id='compare_" + productDetail.productUPC + "']")
            .addClass("remove")
            .removeClass("compare")
            .text(compareTranslatedLabel);
          this.store.dispatch(
            new productActions.AddComparedProduct({
              upc: productDetail.productUPC,
              type: 3,
              locale: this.locale,
            })
          );
        }
      } else {
        this.translate
          .get("compare")
          .subscribe((r) => (compareTranslatedLabel = r));
        $("button[id='compare_" + productDetail.productUPC + "']")
          .addClass("compare")
          .removeClass("remove")
          .text(compareTranslatedLabel);
        this.store.dispatch(
          new productActions.RemoveComparedProduct(productDetail.productUPC)
        );
      }
    }
  }

  createThumbnailList(img) {
    if (window.matchMedia("(max-width: 1280px)").matches) {
      resizeImg(img, this.thumbnailWListLG, this.thumbnailHListLG, this.locale);
    } else {
      resizeImg(img, this.thumbnailWListXL, this.thumbnailHListXL, this.locale);
    }
  }

  createThumbnail(img) {
    resizeImg(img, this.thumbnailWGrid, this.thumbnailHGrid, this.locale);
  }

  showOverlay(productDetail) {
    let popupFlag = false;
    if (popupFlag == false) {
      popupFlag = true;
      showOverlay(
        productDetail,
        this.locale,
        this.store,
        this.hatchOverlayDisplay
      );
    }
  }

  getEANCode(productUPC) {
    return productUPC;
  }

  getFormPath(locale, displayName) {
    var currentdomain = window.location.hostname;
    currentdomain == "localhost" ? (currentdomain = "wwwdev.nvidia.com") : "";

    if (locale == "ru-ru") {
      var path =
        "https://" +
        currentdomain +
        "/" +
        locale +
        "/geforce/graphics-cards/30-series/notify-me-form/";
    } else {
      var path =
        "https://" +
        currentdomain +
        "//content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me/?afAcceptLang=" +
        locale +
        "&productName=" +
        displayName;
    }
    return path;
  }

  transmitToCart() {
    this.cartService.emitChange("Data from child");
    var that = this;
    setTimeout(() => {
      $(".cart-main-section .cart__empty")[0] &&
        ($(".cart-main-section .cart__empty")[0].innerHTML =
          that.translate.instant("empty_cart"));
      $(".cart-main-section .cart__title")[0] &&
        ($(".cart-main-section .cart__title")[0].innerHTML =
          that.translate.instant("cart"));
      $(".cart-main-section .cart__items").each(function () {
        $(this)
          .find(".cart_remove .cart-item__remove")
          .each(function (i) {
            $(".cart_remove .cart-item__remove")[i].innerHTML =
              that.translate.instant("remove");
          });
      });
    }, 100);
  }
}
